/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import CustomDatePicker from '../../../../components/DatePicker';
import { convertDatesToEpochUTC } from '../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat';
import dayjs from 'dayjs';
import moment from 'moment';
import ManageActivityHistoryListExport from '../Export';
import FilterActivityHistory from '../Filter';
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';
import GlobalContext from '../../../../components/Context/GloablContext';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import { useGetHelpGuideAdminQuery } from '../../../../features/patientSlice';


const TopBarAccessLog = ({
    title,
    ApplyFilter,
    filterDateValues,
    setFilterDateValues,
    setFilterValues,
    filterValues,
    initialState,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    data,
    exportAccessLog,
    isIdexport,
    selectedOrganizationName,
    setSelectedOrganizationName,
    setSubDivisionDataLoading,
    userArr,
    subDivisionDataLoading,
    handleApplyFilter,
    TotalCount
}) => {
   
    const { isSideBar,setIsAdvancedSearchOpen,setIsSideBar } = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [dateError, setdateError] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const userType = sessionStorage.getItem('user_type');
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const ref = useRef()
    const ref2 = useRef()
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    const dispatch=useDispatch()



    const handleCheck=(start_date,end_date)=>{
        if((dayjs(end_date).isBefore(dayjs(start_date)))&&(end_date!==undefined&&start_date!==undefined)){
            return true
        }
        return false
    }

    const handleOpenFilter = () => {
        setdateError(false)
        setIsFilterOpen(!isFilterOpen)

        const params = Object.fromEntries(searchParams);
        
        setFilterValues((prev) => ({
            ...prev,
            user_name: params.user_name || '',
            action: params.result || '',
        }));
    }

    function handleSelectDate(id,date,dateString,termkey){
        isFilterOpen&&setIsFilterOpen(false)
        if(id==="filter_end_date"&&filterDateValues?.start_date!==undefined&&handleCheck(filterDateValues?.start_date,dateString)){
            setdateError(true)
            return
        }
        if(id==="filter_start_date"&&filterDateValues?.end_date!==undefined&&handleCheck(dateString,filterDateValues?.end_date)){
            setdateError(true)
            return
        }
        setdateError(false)
        let params = Object.fromEntries(searchParams)
        params.page_number = 1
        params.last_id = null
        params.last_page = null
        
        if(id==="filter_start_date"){
            setFilterDateValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
            
            params.start_date =convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)
            setSearchParams({...params})
            
        }
        else{
            setFilterDateValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
            params.end_date= convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)
            setSearchParams({...params})
        }
        
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
          
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    useEffect(() => {
        setQueryParamsadmin('type=admin-access-logs');
    }, [userType]);
    
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
        
    return (<>
        <div className="flex justify-between items-center xl:mb-[18px] mb-0">
            <div className='flex items-start'>
                <h1 className="text-xl font-normal text-[#000000] min-w-max self-start mt-2">{title}</h1>
                {
                    userType !=='super-admin' &&
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer min-w-max'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }
            </div>
            <div className="flex items-center w-full justify-end relative 2xl:flex-nowrap flex-wrap"> 
                <div className='flex items-center flex-wrap relative justify-end'>
                    <div className='flex items-center relative'>
                        <span className='absolute top-[38px] left-0'>
                            {dateError &&<p className="text-xs text-red-500 mt-2.5 pl-2">Please select the valid date range.</p>}
                        </span>
                        <div className='w-auto mx-2 xl:mb-0 mb-3.5'>
                            <CustomDatePicker 
                                id={"filter_start_date"}
                                classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                format="MMM DD, YYYY"
                                state={filterDateValues}
                                data-testid={"start_date"}
                                placeholder={"Select start date"}
                                termkey={filterDateValues?.start_date}
                                handleSelect={handleSelectDate}
                                imageClass={true}
                                setdateError={setdateError}
                            />
                        </div>
                        <div className='w-auto xl:mb-0 mb-3.5'>
                            <div className='w-full'>
                                <CustomDatePicker
                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                    placeholder={"Select end date"}
                                    format="MMM DD, YYYY"
                                    state={filterDateValues}
                                    termkey={filterDateValues?.end_date}
                                    handleSelect={handleSelectDate}
                                    id={"filter_end_date"}
                                    setdateError={setdateError}
                                />
                            </div>
                        </div>
                    </div>
                    <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max xl:mb-0 mb-3.5">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                    </button>
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterActivityHistory
                            dateError={dateError}
                            setdateError={setdateError}
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            subDivisionDataLoading={subDivisionDataLoading}
                            userArr={userArr}
                            handleApplyFilter={handleApplyFilter}
                        />
                    }
                    
                    {data?.data?.length>0&&<div>  <ManageActivityHistoryListExport
                        selectedRows={selectedRows}
                        exportAccessLog={exportAccessLog}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} username={username}
                        TotalCount={TotalCount}    
                    />
                    </div> }
                </div>
            </div>
        </div>
        {(helpGuideModel && helpguidestatus==="fulfilled") &&
        <HelpGuideModal
            setHelpGuideModel={setHelpGuideModel}
            pdfUrl={helpguidedata} // Pass the PDF URL to the modal
        />
        }
    </>
    );
}

export default TopBarAccessLog;
